<script setup lang="ts">
import { useTheme } from "../composables/useTheme";

const { theme } = useTheme();
</script>

<template>
  <div class="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
    <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" viewBox="0 0 1200 800"
      xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id="shapes-blur" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="140" />
        </filter>
        <template v-if="theme === 'dark'">
          <radialGradient id="shape-lift" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(36% 0.05 250)" stop-opacity="0.75" />
            <stop offset="100%" stop-color="oklch(36% 0.05 250)" stop-opacity="0" />
          </radialGradient>
          <radialGradient id="shape-mid" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(28% 0.04 258)" stop-opacity="0.7" />
            <stop offset="100%" stop-color="oklch(28% 0.04 258)" stop-opacity="0" />
          </radialGradient>
          <radialGradient id="shape-deep" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(22% 0.035 260)" stop-opacity="0.75" />
            <stop offset="100%" stop-color="oklch(22% 0.035 260)" stop-opacity="0" />
          </radialGradient>
        </template>
        <template v-else>
          <radialGradient id="shape-lift" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(92% 0 0)" stop-opacity="0.85" />
            <stop offset="100%" stop-color="oklch(92% 0 0)" stop-opacity="0" />
          </radialGradient>
          <radialGradient id="shape-mid" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(94% 0 0)" stop-opacity="0.8" />
            <stop offset="100%" stop-color="oklch(94% 0 0)" stop-opacity="0" />
          </radialGradient>
          <radialGradient id="shape-deep" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stop-color="oklch(90% 0 0)" stop-opacity="0.85" />
            <stop offset="100%" stop-color="oklch(90% 0 0)" stop-opacity="0" />
          </radialGradient>
        </template>
      </defs>

      <g filter="url(#shapes-blur)">
        <ellipse cx="200" cy="160" rx="400" ry="320" fill="url(#shape-lift)" />
        <ellipse cx="1040" cy="360" rx="440" ry="360" fill="url(#shape-mid)" />
        <ellipse cx="520" cy="740" rx="420" ry="300" fill="url(#shape-deep)" />
        <ellipse cx="880" cy="80" rx="280" ry="220" fill="url(#shape-lift)" />
      </g>
    </svg>
  </div>
</template>
